/**
 * @ File:
 * @ Description:
 * @ Author: cqh
 * @ Create Time: 2023-02-15 18:01:35
 * @ Modified by: cqh
 * @ Modified time: 2023-05-23 22:03:24
 */

import { createContext } from 'react';
/* 
    context  上下文 关联数据使用
 */
export var context = /*#__PURE__*/createContext({});
var Provider = context.Provider,
  Consumer = context.Consumer;
export { Provider, Consumer };